import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card1" }


export default /*@__PURE__*/_defineComponent({
  __name: 'EventCard',
  props: {
    id: {},
    time: {},
    name: {},
    studio: {},
    location: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, _toDisplayString(__props.time), 1),
    _createElementVNode("li", null, _toDisplayString(__props.name), 1),
    _createElementVNode("li", null, _toDisplayString(__props.studio), 1),
    _createElementVNode("li", null, _toDisplayString(__props.location), 1)
  ]))
}
}

})